import { Action } from '@ngrx/store';

export enum MediaActionTypes {
  GET_MEDIAS = '[Medias] GET',
  GET_MEDIAS_SUCCESS = '[Medias] GET Success',
  GET_MEDIAS_FAILURE = '[Medias] GET Failure',

  GET_DECORATIONS = '[Decorations] GET',
  GET_DECORATIONS_SUCCESS = '[Decorations] GET Success',
  GET_DECORATIONS_FAILURE = '[Decorations] GET Failure',

  SET_MEDIA = '[Media] SET Media',
  SET_MEDIA_SUCCESS = '[Media] SET Media Success',
  SET_MEDIA_FAILURE = '[Media] SET Media Failure',

  EDIT_MEDIA = '[Media] EDIT Media',
  CREATE_MEDIA = '[Media] CREATE Media',
  UPDATE_MEDIA = '[Media] UPDATE Media',

}

// MEDIAS
export class GetMedias implements Action {
  readonly type = MediaActionTypes.GET_MEDIAS;
  constructor(public payload: any) {}
}
export class GetMediasSuccess implements Action {
  readonly type = MediaActionTypes.GET_MEDIAS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetMediasFailure implements Action {
  readonly type = MediaActionTypes.GET_MEDIAS_FAILURE;
  constructor(public payload: any) {}
}

// Decorations
export class GetDecorations implements Action {
  readonly type = MediaActionTypes.GET_DECORATIONS;
  constructor(public payload: any) {}
}
export class GetDecorationsSuccess implements Action {
  readonly type = MediaActionTypes.GET_DECORATIONS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetDecorationsFailure implements Action {
  readonly type = MediaActionTypes.GET_DECORATIONS_FAILURE;
  constructor(public payload: any) {}
}


// MEDIA
export class EditMedia implements Action {
  readonly type = MediaActionTypes.EDIT_MEDIA;
  constructor(public payload: any) {}
}
export class CreateMedia implements Action {
  readonly type = MediaActionTypes.CREATE_MEDIA;
  constructor(public payload: any) {}
}
export class SetMedia implements Action {
  readonly type = MediaActionTypes.SET_MEDIA;
  constructor(public payload: any) {}
}
export class SetMediaSuccess implements Action {
  readonly type = MediaActionTypes.SET_MEDIA_SUCCESS;
  constructor(public payload: any) {}
}
export class SetMediaFailure implements Action {
  readonly type = MediaActionTypes.SET_MEDIA_FAILURE;
  constructor(public payload: any) {}
}


export type All =
  | GetMedias
  | GetMediasSuccess
  | GetMediasFailure
  | GetDecorations
  | GetDecorationsSuccess
  | GetDecorationsFailure
  | EditMedia
  | CreateMedia
  | SetMedia
  | SetMediaSuccess
  | SetMediaFailure



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/media.actions.ts